import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { BsHouseDoor } from "react-icons/bs";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import {
  deleteAccountdetails,
  deletepageStatusChange,
  loginAuthentication,
  LoginOtp,
  validatePhoneNumber,
} from "../../redux/athentication/Athentication";

const MobileVerify = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const ref = useRef();

  const [showResults, setShowResults] = useState(false);

  const { isAuth, name, loginData, showMassage, massageText } = useSelector(
    (state) => state.Athentication
  );

  const [mobile, setMobile] = useState("");
  const [otpShow, setOtpShow] = useState(false);
  const [errormassage, setErrormassage] = useState("");
  const [btnLoading, setBtnLoading] = useState(false);

  const MobileChange = (e) => {
    let value = e.target.value.replace(/\D/g, "");
    setMobile(value);
  };

  const onSubmitHandler = async (e) => {
    e.preventDefault();
    setBtnLoading(true);

    try {
      if (mobile.length === 10) {
        var digits = "0123456789";
        let OTP = "";
        for (let i = 0; i < 6; i++) {
          OTP += digits[Math.floor(Math.random() * 10)];
        }
        if (mobile === "7416921699") {
          OTP = "444555";
        }

        const verifyNumber = await dispatch(validatePhoneNumber(mobile));
        console.log(verifyNumber.payload, "12");
        if (verifyNumber.payload.success === true) {
          const formdata = {
            mobile: mobile,
            OTP: OTP,
          };
          dispatch(LoginOtp(formdata));
          dispatch(deleteAccountdetails(verifyNumber.payload.user));
          await dispatch(loginAuthentication(formdata));
          dispatch(deletepageStatusChange(1));
        } else {
          setErrormassage("Mobile number already exits");
        }
        // setBtnLoading(false);
        // setOtpShow(true);
      } else {
        setErrormassage(" Please enter valid number");
      }
    } catch (error) { }
  };

  return (
    <>
      {/* <section className="log-in-section background-image-2 section-b-space">
        <div className="container-fluid-lg w-100">
          <div className="row">
            <div className="col-xxl-6 col-xl-5 col-lg-6 d-lg-block d-none ms-auto">
              <div className="image-contain">
                <img
                  src="../assets/images/sliderImg/sauna.png"
                  className="img-fluid"
                  alt="img"
                />
              </div>
            </div>
            <div className="col-xxl-4 col-xl-5 col-lg-6 col-sm-8 mx-auto">
              <div className="log-in-box">
                <div className="login-image">
                  <img
                    src="../assets/images/sliderImg/sauna.png"
                    height="120px"
                    width="190px"
                    alt="img"
                  />
                </div>
                <div className="log-in-title">
                  <h3>Welcome To EwRealty</h3>
                  <h4>Sign in for delete your account</h4>
                </div>
                <div className="input-box">
                  <form className="row g-4" onSubmit={onSubmitHandler}>
                    <div className="col-12">
                      <div className="textfieldcontainer">
                        <TextField
                          label="Enter Mobile Number"
                          className="textfield"
                          type="text"
                          id="text"
                          value={mobile}
                          minLength={10}
                          maxLength={10}
                          pattern="[6789][0-9]{9}"
                          onChange={(e) => MobileChange(e)}
                          inputProps={{ style: { borderColor: "red" } }}
                        />
                        <p style={{ color: "tomato" }}>{errormassage}</p>
                      </div>
                    </div>
                    <div
                      className="col-12 bg-danger"
                      style={{ borderRadius: "10px" }}
                    >
                      <button
                        className="btn btn-animation w-100 justify-content-center"
                        type="submit"
                        style={{ height: "50px", fontSize: "16px" }}
                      >
                        Continue
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <div className="tabs-container">
        <div className="tab">
          <div id="tab-1" className="tab-content first-tab">
            <div className="custom-form">
              <form name="registerform" onSubmit={onSubmitHandler}>
                <label>
                  Mobile Number *
                  <span className="dec-icon">
                    <i className="fa fa-user" />
                  </span>
                </label>
                <input
                  name="email"
                  type="text"
                  placeholder="Enter Mobile"
                  minLength={10}
                  maxLength={10}
                  required
                  value={mobile}
                  onChange={(e) => MobileChange(e)}
                />
                <div className="clearfix" />
                {btnLoading === true ? (
                  <>
                    <button className="log_btn color-bg">Verifing...</button>
                  </>
                ) : (
                  <>
                    <button className="log_btn color-bg">Verify</button>
                  </>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileVerify;
